export default __webpack_public_path__ + "static/media/tv3.f1eca6a0.jpeg";